export const prefix = 'boost-sd__';
export const DEFAULT_SELECTOR = {
  productItem: `.${prefix}product-item, .product-item-list-view-layout, .${prefix}suggestion-queries-item--product`,
  addToCart: `.${prefix}button--purchase,.${prefix}btn-add-to-cart:not(.boost-sd__button--preorder),.${prefix}button--select-option[aria-label="Add to cart"], form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"]`,
  buyNow: `.${prefix}btn-buy-now, .shopify-payment-button__button:not(.product-recommendations .shopify-payment-button__button), .shopify-payment-button, #dynamic-checkout-cart:not(:has(shopify-accelerated-checkout-cart, shop-pay-wallet-button, shopify-google-pay-button))`,
  quickView: `.${prefix}button--quick-view`,
  recommend: `.${prefix}recommendation`,
  suggest: `.${prefix}instant-search-container`,
  inputQuantity: `.quantity__input, .quantity-selector__value, .quantity-selector__input, input#quantity, .select-popout__toggle span, .js-qty__num, .product-form__qty-input input, .product-form__quantity input, .js-qty-input`,
  quickViewQuantityInput: `.${prefix}input-number-input`,
  filterOption: `.${prefix}filter-option-item-button`,
  preOrder: `.${prefix}button--preorder`,
  ourBuyNow: `${prefix}btn-buy-now`,
};

export const ANALYTICS_URL =
  window.boostWidgetIntegrationConfig?.analytics?.analyticsUrl ||
  window?.boostWidgetIntegration?.app?.[window?.boostWidgetIntegration?.env || 'production']
    ?.analyticsUrl ||
  (window?.boostWidgetIntegration?.env === 'staging'
    ? 'https://lajhlox2el.execute-api.us-west-2.amazonaws.com/staging/e'
    : 'https://lambda.mybcapps.com/e');

export const USER_ACTION = {
  VIEW_PRODUCT: 'view_product',
  VIEW_PRODUCT_PRE_ORDER: 'view_product_pre_order',
  QUICK_VIEW: 'quick_view',
  ADD_TO_CART: 'add_to_cart',
  BUY_NOW: 'buy_now',
  ATC_PRE_ORDER: 'add_to_cart_pre_order',
};

export const PRE_ACTION = 'boostSdPreAction';
export const DATA_NOT_SEND = 'boostSdDataNotSent';
export const RECOMMEND_ACTIVE = 'boostSdCurrentRecommendActive';
export const BOOST_SD_PRODUCT_IDS_CLICKED = 'boostSdProductIdsClicked';
export const REQUEST_ID_PRE_ORDER_VIEW = 'boostSdRequestIdPreOrderView';

// this event open popup of bundle in ISW
export const excludeAddToCartOurApp = ['.boost-sd__recommendation-dynamic-show-popup'];
export const DYNAMIC_BUNDLE_TYPE = 'dynamic-bundle';
export const PopupBundlePlacement = 'popup-bundle-placement';

export const PLACEMENT = {
  product_page: 'product_page',
  search_page: 'search_page',
  instant_search: 'instant_search',
};

export const ACTION = {
  FILTER: 'filter',
  SEARCH: 'search',
  SUGGEST: 'suggest',
  RECOMMEND: 'recommend',
};

export const KLAVIYO_BOOST_EVENT = {
  CLICK_SEARCH_RESULT: '[Boost] Clicked Search Result',
  ADD_TO_CART: '[Boost] Added To Cart',
  VIEW_COLLECTION: '[Boost] Viewed Collection',
  CLICK_PRODUCT: '[Boost] Clicked Product',
  ADD_BUNDLE_TO_CART: '[Boost] Added Bundle To Cart',
  CLICK_RECOMMENDATION: '[Boost] Clicked Recommendation',
  SUBMIT_SEARCH: '[Boost] Submitted Search',
  CLICK_FILTER: '[Boost] Clicked Filter',
  PRE_ORDER: '[Boost] Pre-Order Added to cart',
};

export const MAP_PATH_CLICK = {
  [ACTION.SEARCH]: 'Search page',
  [ACTION.SUGGEST]: 'Instant search',
};

export const INTEGRATION_STATUS_ACTIVE = 'active';

export const BOOST_CART_TOKEN = {
  PREFIX: 'bct-',
  SHORT_KEY: 'bct',
  STORAGE_KEY: 'boost_cart_token',
};

export const SHOPIFY_CART_TOKEN = 'shopify_cart_token';

export const ATTENTIVE_USER_INFO_KEY = 'attentiveUserInfo';
export const ATTENTIVE_LISTENING_ORIGIN = 'https://creatives.attn.tv';
export const ATTENTIVE_BOOST_EVENT = {
  CLICK_SEARCH_RESULT: 'Boost - Clicked Search Result',
  ADD_TO_CART: 'Boost - Added To Cart',
  VIEW_COLLECTION: 'Boost - Viewed Collection',
  CLICK_PRODUCT: 'Boost - Clicked Product',
  ADD_BUNDLE_TO_CART: 'Boost - Added Bundle To Cart',
  CLICK_RECOMMENDATION: 'Boost - Clicked Recommendation',
  SUBMIT_SEARCH: 'Boost - Submitted Search',
  CLICK_FILTER: 'Boost - Clicked Filter',
  PRE_ORDER: 'Boost - Pre-Order Added to cart',
};
